// src/Pages/Landing/JoyrideEspooLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";

export default function JoyrideEspooLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Espoo"
      maakunta="Uusimaa"
      nearbyAreas={[
        "Helsinki",
        "Vantaa",
        "Kauniainen",
        "Kirkkonummi",
        "Kerava",
        "Järvenpää"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Espoossa tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Espoo sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja yksityistilaisuuksiin, kun juhliin halutaan energinen livebändi."
      logisticsText="Bilebändi Joyride tulee Keski-Uudeltamaalta, joten Espoo on selkeä keikkakohde pääkaupunkiseudulla. Oma kuljetus, oma äänentoisto ja valotekniikka helpottavat juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
    />
  );
}